/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.15.0
 * @since 1.1.0
 */

import { FlexMiddleStyled } from '../../../../../components/common/Block/Flexbox';
import { IPageExpensesAnalyzerController } from '../../../../../modules/internationalization/types';
import { ONBOARDING_DATA_ATTR } from '../../../../../modules/onboarding/onboardingConstants';
import { mapExpensesTypeToOnboarding } from '../../../types/pageExpensesAnalyzerMapTypes';
import { EExpensesAnalyzerTypes } from '../../../types/pageExpensesAnalyzerTypes';
import { EExpensesAnalyzerChart } from '../expensesAnalyzerControllerTypes';
import { ExpensesAnalyzerChartTabStyled } from './styled/ExpensesAnalyzerChartStyled';

interface IExpensesAnalyzerChartProps {
    currentChart: EExpensesAnalyzerChart;
    expensesAnalyzerType: EExpensesAnalyzerTypes;
    onTabClick: (chart: EExpensesAnalyzerChart) => void;
    translation: IPageExpensesAnalyzerController;
}

const ExpensesAnalyzerChartTab = (props: IExpensesAnalyzerChartProps) => (
    <FlexMiddleStyled
        {...{ [ONBOARDING_DATA_ATTR]: mapExpensesTypeToOnboarding[props.expensesAnalyzerType]?.chartTab }}
    >
        <ExpensesAnalyzerChartTabStyled
            data-name='chartTabCategory'
            isActive={props.currentChart === EExpensesAnalyzerChart.CATEGORY}
            onClick={() => props.onTabClick(EExpensesAnalyzerChart.CATEGORY)}
        >
            {props.translation.chartCategory}
        </ExpensesAnalyzerChartTabStyled>
        <ExpensesAnalyzerChartTabStyled
            data-name='chartTabDynamic'
            isActive={props.currentChart === EExpensesAnalyzerChart.DYNAMIC}
            onClick={() => props.onTabClick(EExpensesAnalyzerChart.DYNAMIC)}
        >
            {props.translation.chartDynamic}
        </ExpensesAnalyzerChartTabStyled>
    </FlexMiddleStyled>
);

export default ExpensesAnalyzerChartTab;
